import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'ACTIVITY_UPDATE',
    smsDelete : 'ACTIVITY_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        activity: [],
        activity_count:null,
        submitLoading: false,
        submitError: false,
        submitSuccess: false,
   

        ...store
    },

    mutations : {
        ...mutations,
        SET_ACTIVITY (state, {results,pg_count}) {
            state.activity = results;
            state.activity_count = pg_count;
        },
       

        SUBMIT_LOADING (state, loading) {
            state.submitLoading = loading;
        },

        SUBMIT_ERROR (state, hasError) {
            state.submitError = hasError;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

       
    },

    actions: {
      

        async deleteActivity ({dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.delete_activity + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })

            dispatch ('fetchActivity', {currentPage:payload.page,perPage:payload.perPage, status:payload.status,raised_by:payload.raised_by,search_term:payload.search_term})

            return response
        },

        async fetchActivity ({ commit },payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let params = new URLSearchParams();
        
                if (payload.perPage) params.append('count', payload.perPage);
                if (payload.currentPage) params.append('page', payload.currentPage);
                if (payload.start_date) params.append('start_date', payload.start_date);
                if (payload.end_date) params.append('end_date', payload.end_date);
                if (payload.status) params.append('status', payload.status);
                if (payload.search_term) params.append('search_term', payload.search_term);
                if (payload.raised_by) params.append('raised_by', payload.raised_by);
               
           
                let url = V1API.get_activity_log + '?' + params.toString();
                let result = await axios.get(url, config);

                const {results, pg_count} = result.data

                commit('SET_ACTIVITY', {results, pg_count});
                return result
               

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            }
            finally {
                commit('SUBMIT_LOADING', false);
            }
        },







    },

    getters: {}
}
